export default __webpack_public_path__ + "static/media/video_on.9f337c6d.svg";